
/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, ref, onBeforeMount, watchEffect } from "vue";
import RadioButton from "../../components/radioButton/index.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { JobsAPI } from "../../services/jobs/index";
import { useStore } from "vuex";
import CheckBoxGroup from "../checkboxGroup/index.vue";

const RequirementsTemplates = defineComponent({
  name: "RequirementsTemplates",
  emits: ["closeModal", "addToInput"],
  components: {
    RadioButton,
    Loading,
    CheckBoxGroup,
  },
  setup(props, context) {
    const radioOption = ref("");
    const store = useStore();
    const isLoading = ref(false);
    const templeteOptions = ref([]);
    const checkValues = ref([]);
    const templateDescription = ref({});
    const content = ref([]);
    onBeforeMount(() => {
      isLoading.value = true;
      JobsAPI.getJobTemplates({ by_type: 2 }).then((res: any) => {
        isLoading.value = false;
        templeteOptions.value = res.data;
      });
    });

    const getTemplateInfo = () => {
      isLoading.value = true;
      checkValues.value = [];
      JobsAPI.getOneTemplate(radioOption.value).then((res: any) => {
        isLoading.value = false;
        templateDescription.value = res.data;
        content.value = checkValues.value;
      });
    };
    watchEffect(() => {
      if (radioOption.value !== "") {
        getTemplateInfo();
      }
    });
    const closeModal = () => {
      context.emit("closeModal");
    };
    const saveTemplate = () => {
      store.commit("TEMPLATE_REQUIREMENTS_FULLFILED", checkValues.value);
      closeModal();
      context.emit("addToInput");
    };
    return {
      templeteOptions,
      radioOption,
      isLoading,
      templateDescription,
      content,
      saveTemplate,
      closeModal,
      checkValues,
    };
  },
});
export default RequirementsTemplates;
